import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tilatunnus-cell" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "no-data"
}

import { Warning } from "@element-plus/icons-vue"
import { TilaResponse } from "@/api/models/tila-response"
import { useHuonekorttiTableWithDuplicates } from "./huonekorttiTable"
import { hankePage } from "@/views/hanke"


export default /*@__PURE__*/_defineComponent({
  __name: 'ComHuonekorttiTilatTable',
  props: {
    tilat: {}
  },
  setup(__props: any) {

const { id: hankeId } = hankePage()
const { isDuplicateTilatunnus } = useHuonekorttiTableWithDuplicates(hankeId)



return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, {
    data: __props.tilat,
    size: "small",
    class: "tilat-table",
    style: {"width":"100%"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, {
        label: "Tilatunnus",
        prop: "tilatunnus",
        "show-overflow-tooltip": ""
      }, {
        default: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_tag, {
              type: _unref(isDuplicateTilatunnus)(scope.row.tilatunnus) ? 'warning' : 'info'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.tilatunnus), 1)
              ]),
              _: 2
            }, 1032, ["type"]),
            (_unref(isDuplicateTilatunnus)(scope.row.tilatunnus))
              ? (_openBlock(), _createBlock(_component_el_icon, {
                  key: 0,
                  color: "#e6a23c"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Warning))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "Pinta-ala",
        prop: "pintaAla",
        "show-overflow-tooltip": ""
      }, {
        default: _withCtx((scope) => [
          (scope.row.pintaAla)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(scope.row.pintaAla) + " m²", 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, "-"))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})